import React from 'react';
import { FaMapMarkerAlt, FaTimes, FaCog } from 'react-icons/fa';
import { PERMISSION_STATUS } from '../context/LocationPermissionContext';
import './LocationPermissionPopup.css';

function LocationPermissionPopup({ onEnable, onClose, permissionStatus }) {
    const isBlocked = permissionStatus === PERMISSION_STATUS.DENIED;

    return (
        <div className="location-popup-overlay">
            <div className="location-popup-content">
                <button className="location-popup-close" onClick={onClose}>
                    <FaTimes />
                </button>

                <div className="location-popup-icon">
                    <FaMapMarkerAlt />
                </div>

                <h3 className="location-popup-title">Enable Location</h3>

                <p className="location-popup-description">
                    {isBlocked
                        ? "Location access was previously denied. To use features like Nearby Places, please enable location access."
                        : "VaahanBuddy needs your location to show nearby petrol pumps, mechanics, charging stations, and more."
                    }
                </p>

                {isBlocked && (
                    <div className="location-popup-instructions">
                        <div className="instruction-header">
                            <FaCog /> <span>How to enable location:</span>
                        </div>
                        <ol>
                            <li>Click the lock/info icon in your browser's address bar</li>
                            <li>Find "Location" in the permissions list</li>
                            <li>Change it from "Block" to "Allow"</li>
                            <li>Refresh the page</li>
                        </ol>
                    </div>
                )}

                <div className="location-popup-buttons">
                    <button className="location-popup-cancel" onClick={onClose}>
                        Cancel
                    </button>
                    <button className="location-popup-enable" onClick={onEnable}>
                        {isBlocked ? "Try Again" : "Enable Location"}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default LocationPermissionPopup;
